// extracted by mini-css-extract-plugin
export default {"wrapper":"secc_1_wrapper__LrAI+","hero":"secc_1_hero__fkqW3","icon":"secc_1_icon__-GUbr","secondaryBtn":"secc_1_secondaryBtn__rzj0i","features":"secc_1_features__Ek1EW"};